module.exports = __webpack_public_path__ + "img/dark-mode-logo.c27c2fd7.svg";